<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes + classObj" style="z-index:200">
        <span>COPYRIGHT &copy; {{ new Date().getFullYear() }} , All rights Reserved</span>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    },
    computed: {
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default")      return "navbar-default"
      else if (this.verticalNavMenuWidth == "reduced") return "footer-reduced"
      else if (this.verticalNavMenuWidth)              return "navbar-full"
    }
    }
}
</script>
<style scoped>
.footer-reduced {
    z-index: 200;
}
</style>
